import { render, staticRenderFns } from "./H1ParcelItemsTab.vue?vue&type=template&id=474bbe68&"
import script from "./H1ParcelItemsTab.vue?vue&type=script&lang=js&"
export * from "./H1ParcelItemsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports